export default __webpack_public_path__ + "static/avatar-special-halloween-0-e5ee35bd0230de4aaa247ff62e180215.png";